module.exports = __webpack_public_path__ + "img/chat.4adbfb26.svg";